import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@src/environments/environment";
import { SessionHelper } from "./sessionHelper";

@Injectable({
  providedIn: "root",
})
export class PushNotificationService {
  private messageListenerAttached = false;

  constructor(private http: HttpClient) {}

  async init(onPush: (payload: any) => void) {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      return;
    }

    if (!this.messageListenerAttached) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "push-notification") {
          onPush(event.data.payload);
        }
      });
      this.messageListenerAttached = true;
    }

    try {
      const registration = await navigator.serviceWorker.register("/push-sw.js");

      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        return;
      }

      let subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(environment.vapidPublicKey),
        });
      }

      this.syncSubscription(subscription);
    } catch (error) {
      console.warn("Push notification setup failed", error);
    }
  }

  private syncSubscription(subscription: PushSubscription) {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      withCredentials: true,
    };
    this.http
      .put(
        environment.apiUrl + "/notification/person/" + SessionHelper.getUserSub(),
        subscription.toJSON(),
        httpOptions
      )
      .subscribe({ error: () => {} });
  }

  private urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
}
